// 所有的异常状态对照信息

/**
 * 认证授权相关
 */
const auth = {
  8412: '该手机已注册，可以通过密码快捷登录',
  8400: '认证格式异常', // 认证格式异常，例如必须字段为空
  8401: '认证类型错误', // 不支持的认证类型
  8402: '用户名密码不匹配', // 非法的认证信息，例如用户名密码不匹配
  8403: '账户未激活', // 员工状态异常，例如必须为待激活状态的员工，才能激活。正常状态才能登录
  8404: '当前账户未绑定群组信息', // 员工没有群组
  // 8405: 'token错误', // Token非法
  8406: '未找到当前用户', // 找不到员工
  8407: '短信验证码异常', // 短信验证码异常
  50221: '您输入的手机号码未在平台注册，请使用已注册账号进行密码修改！',
  50202: '您输入的旧密码不正确！请重新检查后提交！',
  52604: '该账号已绑定微信用户'
}

/**
 * 员工相关
 */
const user = {
  9401: '操作错误,请点击重试（9401）', // 字段属性异常
  9402: '手机号码重复，请更换手机号码重试', // 电话重复
  9403: '手机号码无法更改', // 不允许修改电话
  9404: '无当前用户', // 找不到
  9405: '用户角色无效' // 非法角色
}

/**
 * 部门相关
 */
const dept = {
  9001: '当前部门存在子节点', // 部门存在子节点
  9002: '找不到父节点', // 部门存在子节点
  9003: '节点不存在', // 目标节点不存在
  9005: 'code重复',
  9010: '机构代码重复'
}

/**
 * 角色相关
 */
const role = {
  9301: '存在子节点', // 存在子节点
  9302: '找不到父节点', // 找不到父节点
  9303: '角色不存在', // 找不到角色
  9006: '该人员已经存在，如有需要请联系商户负责人进行调整'
}

const task = {
  50241: '题库数量不足请联系管理员',
  50242: '提交失败！',
  50234: '任务已提交，请勿重复提交',
  50260: '您已恢复接单，请开始搬砖',
  50254: '您已被暂停接单，请开始练习',
  50258: '当前待处理单量大于 200 单，请及时处理!',
  10203: '暂无任务，请点击领取',
  10202: '当前没有可领取的标注集',
  10204: '任务已领取请刷新重试',
  10206: '任务异常，请联系技术处理',
  50113: '当前任务已失效，请返回首页刷新后重新接单',
  50114: '当前任务已完成，请返回首页刷新后重新接单',
  50106: '您提交的商品没有在候选集中，请重新选择后在提交！',
  50102: '该任务已上报，请勿重复上报',
}

// 提现
const withdrawal = {
  50621: '今日 23:00 ~ 次日 1:00 禁止兑现，请其他时间进行兑现'
}

export default {
  ...auth,
  ...dept,
  ...role,
  ...user,
  ...task,
  ...withdrawal
}
